import { FC, useEffect, useState } from "react";
import { getAdministrative } from "../../../api/transport/staffTransport";
import { PersonCard, PersonList } from "../../../components/PersonCard";
import { StaffDto } from "../../../types/staff";
import { Loader } from "../../../components/Loader";
import { getFormattedDateNumeric, getStaticUrl, setDocumentTitle } from "../../../utils";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { SiteType } from "../../../types/common";

interface AdministrativePageProps { }

const AdministrativePage: FC<AdministrativePageProps> = ({ }) => {
    const [loading, setLoading] = useState(true);
    const [staff, setStaff] = useState<StaffDto[]>([]);
    const config = useConfiguration();

    useEffect(() => {
        setLoading(true);
        getAdministrative(config?.teamName)
            .then((data) => {
                setStaff(data);
            })
            .finally(() => {
                setLoading(false);
            });
        setDocumentTitle(`Административный персонал - Официальный сайт ${config.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
    }, [config?.teamName]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="max-w-[1000px] mx-auto p-2 pb-6">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">Административный персонал</h1>
            <PersonList>
                {staff.map(manager => (
                    <PersonCard
                        key={manager.uuid}
                        name={manager.fullName}
                        title={manager.title}
                        photo={getStaticUrl(manager.photoUrl)}
                        birthDate={manager.birthDate ? getFormattedDateNumeric(new Date(manager.birthDate)) : ''}
                    />
                ))}
            </PersonList>
        </div>
    );
}

export default AdministrativePage;